import {t} from "./Translate.js";

/**
 * Instructiefilm-specific formatting functions
 */
export class IfwFormat {
	/**
	 * Format a PHP style duration to a readable and translated string
	 *
	 * @return string
	 * @param v
	 */
	public static ifwDuration(v: string): string {
		if (v.substring(0, 2) !== "PT") {
			return "";
		}
		let retStr = "";
		v = v.substring(2);
		let arV = v.split("H");
		if (arV[0] && arV[0].match(/^[0-9]+$/)) {
			if ( parseInt(arV[0]) !== 0) {
				retStr += arV[0] + " " + t("Hours");
			}
			v = arV[1];
		}
		arV = v.split("M");
		if (arV[0].match(/^[0-9]+$/)) {
			retStr += arV[0] + " " + t("Minutes");
		}
		return retStr;
	}

	/**
	 * convert a duration string to number of minutes
	 * @param v
	 */
	public static ifwDurationToMinutes(v: string): number {
		let m = 0;
		if (v.substring(0, 2) !== "PT") {
			return m;
		}
		v = v.substring(2);
		let arV = v.split("H");
		if (arV[0] && arV[0].match(/^[0-9]+$/)) {
			m += parseInt(arV[0]) * 60;
			v = arV[1];
		}
		arV = v.split("M");
		if (arV[0].match(/^[0-9]+$/)) {
			m += parseInt(arV[0]);
		}

		return m;
	}


	/**
	 * convert a number of minutes to a duration string
	 * @param v
	 */

	public static ifwMinutesToDuration(v: number): string {
		if(v < 0) {
			return "PT0M";
		}
		const h = Math.floor((v / 60)), m = v % 60;
		let retStr = "PT";
		if(h > 0) {
			retStr += h+"H";
		}
		retStr += m +"M";
		return retStr;

	}
}